export default __webpack_public_path__ + "static/media/profilePic.32bfbecf.jpg";